import { MessageCircle, PhoneCall } from "lucide-react";
import { companyConfig } from "@/data/siteContent";
import { useLanguage } from "@/context/LanguageContext";

export const ContactFloatingBtn = () => {
  const { isArabic } = useLanguage();

  return (
    <div
      className={`fixed bottom-5 z-40 flex flex-col gap-3 ${isArabic ? "left-5" : "right-5"}`}
      data-testid="floating-contact-buttons"
    >
      <a
        href={companyConfig.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-white shadow-lg transition-colors duration-300 hover:bg-secondary/90"
        data-testid="floating-whatsapp-button"
        aria-label="WhatsApp"
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href={`tel:${companyConfig.phone}`}
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-lg transition-colors duration-300 hover:bg-primary/90"
        data-testid="floating-phone-button"
        aria-label="Phone"
      >
        <PhoneCall className="h-5 w-5" />
      </a>
    </div>
  );
};
